import { UTCDate } from '@date-fns/utc';
import { getTime } from 'date-fns';
import { DataEntities } from './data-provider';

export const getLastUpdated = (data: DataEntities): Record<keyof DataEntities, string> => {
  const timestamps = Object.entries(data).map(([entityName, entityList]) => {
    // If an entity is empty, we return the current date
    if (!entityList.length) {
      return [entityName, new UTCDate().toISOString()];
    }

    // Gets array of timestamps in milliseconds
    const updatedAtList = entityList.map((e) => getTime(new UTCDate(e.updatedAt).toISOString()));

    // Returns tuple with largest timestamp (most recent date)
    return [entityName, new UTCDate(Math.max(...updatedAtList)).toISOString()];
  });

  return Object.fromEntries(timestamps);
};
